import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BarrierOpenModeNamePipe } from '@zaoblako/web/shared/pipes/barrier-open-mode-name.pipe';
import { BarrierOpenModeEnum } from '@zaoblako/shared/modules/cctv/enums/barrier-open-mode.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-barrier-open-mode-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, BarrierOpenModeNamePipe],
  templateUrl: './barrier-open-mode-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BarrierOpenModeSingleSelectComponent {
  public modes: BarrierOpenModeEnum[] = Object.values(BarrierOpenModeEnum);

  @Input() public selectedMode: BarrierOpenModeEnum;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public disabled: boolean;
  @Input() public appendTo: string;

  @Input() public isError = false;
  @Input() public showClear = false;

  @Output() public selectedModeChange = new EventEmitter<BarrierOpenModeEnum>();
}
